export default __webpack_public_path__ + "assets/icons/check.58ef7ac8.svg";